import { useTranslation } from 'react-i18next';
import { CustomFieldOptionType } from '../../components/CustomField/CustomField.type';
import { customSWRConfig } from '../../model/types';
import useGroups from './useGroups';

const groupNameListCreatedBySystem = ['Default Group', 'Agents', 'Chat', 'Call'];
export function useTranslatedGroupOptions(
    options: Omit<CustomFieldOptionType, 'order'>[]
): Omit<CustomFieldOptionType, 'order'>[] {
    const { t } = useTranslation('forms');
    return (options ?? []).map((option) =>
        groupNameListCreatedBySystem.includes(option.label as string)
            ? { ...option, label: t(`form.GroupNames.${option.label}` as any) as string }
            : option
    );
}
export default function useGroupsAsOptions(
    config: {
        labelInValue?: boolean;
        stringValue?: boolean;
    } = {},
    swrConfig: customSWRConfig = {}
): Omit<CustomFieldOptionType, 'order'>[] {
    const { labelInValue = false, stringValue = false } = config;
    const { data: groupList } = useGroups(swrConfig);
    const groupOptions = groupList?.map(({ id, name }) => ({
        value: labelInValue ? name : stringValue ? id.toString() : id,
        key: id.toString(),
        label: name
    }));

    return useTranslatedGroupOptions(groupOptions);
}

export { groupNameListCreatedBySystem };
